export const AQI_LEVELS = {
  good: 'good',
  moderate: 'moderate',
  unhealthySensitive: 'unhealthySensitive',
  unhealthy: 'unhealthy',
  veryUnhealthy: 'veryUnhealthy',
  hazardous: 'hazardous',
} as const;

export const AQI_LEVELS_COLORS = {
  [AQI_LEVELS.good]: '#509F4E',
  [AQI_LEVELS.moderate]: '#FBDA2D',
  [AQI_LEVELS.unhealthySensitive]: '#F19437',
  [AQI_LEVELS.unhealthy]: '#E25345',
  [AQI_LEVELS.veryUnhealthy]: '#A750FF',
  [AQI_LEVELS.hazardous]: '#8D0120',
} as const;

export const AQI_LEVELS_LOWER_BOUNDS = {
  [AQI_LEVELS.good]: 0,
  [AQI_LEVELS.moderate]: 51,
  [AQI_LEVELS.unhealthySensitive]: 101,
  [AQI_LEVELS.unhealthy]: 151,
  [AQI_LEVELS.veryUnhealthy]: 201,
  [AQI_LEVELS.hazardous]: 301,
} as const;

export const AQI_CHART_LEVELS_TO_TRANSLATION_KEYS = {
  [AQI_LEVELS.good]: 'aqiSensors.levels.good',
  [AQI_LEVELS.moderate]: 'aqiSensors.levels.moderate',
  [AQI_LEVELS.unhealthySensitive]: 'aqiSensors.levels.unhealthySensitive',
  [AQI_LEVELS.unhealthy]: 'aqiSensors.levels.unhealthy',
  [AQI_LEVELS.veryUnhealthy]: 'aqiSensors.levels.veryUnhealthy',
  [AQI_LEVELS.hazardous]: 'aqiSensors.levels.hazardous',
} as const;
